import React from 'react';
import { useTranslation } from 'react-i18next';
import { MobileSheet } from './MobileSheet';
import { NmButton } from './NmButton';
import type { InstallPromptKind } from '../utils/pwaEnvironment';

interface Props {
  open: boolean;
  kind: InstallPromptKind;
  canNativeInstall: boolean;
  onDismiss: () => void;
  onInstallAndroid?: () => void;
}

export function InstallAppSheet({
  open,
  kind,
  canNativeInstall,
  onDismiss,
  onInstallAndroid,
}: Props) {
  const { t } = useTranslation();

  if (kind === 'none') return null;

  const isIos = kind === 'ios';

  return (
    <MobileSheet
      open={open}
      onClose={onDismiss}
      title={t('pwa.install.title')}
      subtitle={isIos ? t('pwa.install.subtitleIos') : t('pwa.install.subtitleAndroid')}
      footer={
        <div className="install-app-sheet__footer">
          {kind === 'android' && canNativeInstall && onInstallAndroid ? (
            <NmButton variant="primary" onClick={() => void onInstallAndroid()}>
              {t('pwa.install.installButton')}
            </NmButton>
          ) : null}
          <NmButton variant="ghost" onClick={onDismiss}>
            {t('pwa.install.later')}
          </NmButton>
        </div>
      }
    >
      <div className="install-app-sheet">
        <p className="install-app-sheet__lead">{t('pwa.install.benefits')}</p>
        <ol className="install-app-sheet__steps">
          {isIos ? (
            <>
              <li>{t('pwa.install.iosStep1')}</li>
              <li>{t('pwa.install.iosStep2')}</li>
              <li>{t('pwa.install.iosStep3')}</li>
            </>
          ) : (
            <>
              <li>{t('pwa.install.androidStep1')}</li>
              <li>{t('pwa.install.androidStep2')}</li>
            </>
          )}
        </ol>
        {isIos ? (
          <p className="install-app-sheet__hint">{t('pwa.install.iosPushHint')}</p>
        ) : null}
      </div>
    </MobileSheet>
  );
}
